import {clsx} from 'clsx';
import {memo} from 'react';
import type {HTMLAttributes} from 'react';

import {borderlessTriangle, triangle} from './styles.css.js';

type ArrowProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: 'default' | 'borderless';
};

export const Arrow = memo(function Arrow({
  className,
  variant = 'default',
  ...rest
}: ArrowProps) {
  const classes = clsx(
    variant === 'default' ? triangle : borderlessTriangle,
    className
  );
  return <span {...rest} className={classes} role="img" aria-label="Arrow" />;
});
